import styled from 'styled-components';
import { FONTS, SIZE } from '@app/src/ui';
import { Button } from '@app/src/common/Button';

export const TermsAndConditions = styled.p`
  font-size: 12px;
  margin-left: 8px;

  a {
    font-size: 12px;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;

    a {
      font-size: 14px;
    }
  }
`;

export const FormWrapper = styled.form`
  padding: 0 40px 40px;
  max-width: 360px;
  margin: 0 auto;
  font-family: ${FONTS.OPEN_SANS};
`;

export const Title = styled.h2`
  font-size: 16px;
  margin: 24px 0;
  text-align: center;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 18px;
  }
`;

export const ButtonLogin = styled(Button)`
  margin: 37px auto 16px;
`;

export const FieldWrapper = styled.div`
  margin-bottom: 16px;
`;

export const Session = styled.p`
  font-size: 12px;
  text-align: center;
  margin-bottom: 20px;
  a {
    color: blue;
    font-size: 12px;
    cursor: pointer;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;

    a {
      font-size: 14px;
    }
  }
`;